/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Password_MissingInputs */

const fr_account_audit_password_missing = /** @type {(inputs: Account_Audit_Password_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe non défini`)
};

/**

* @param {Account_Audit_Password_MissingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_password_missing = /** @type {((inputs?: Account_Audit_Password_MissingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Password_MissingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_password_missing(inputs)
});